import React from 'react';
import { Dropdown } from 'freemium-ui';
import { useTranslation } from 'react-i18next';

const FilterDropdown = ({
  label,
  selected,
  options,
  handleChange,
  placeholder,
}: any) => {
  const { t } = useTranslation();

  const selectedItem = selected
    ? options.find(
        (a: any) =>
          a?.display_id === selected ||
          a?.id === selected ||
          (selected?.id &&
            (a?.id === selected?.id || a?.id === selected?.display_id)),
      )
    : null;

  return (
    <Dropdown
      label={label || ''}
      defaultSelectedItem={selectedItem || ''}
      items={options}
      emptyItemsText={`${t('no_results_found')}`}
      onChange={(val: any) => handleChange(val)}
      placeholder={`${t(placeholder)}`}
      itemComponent={(c: any) => <span>{t(c.name) || t(c.label)}</span>}
      itemToString={(c: any) => (c && t(c.name)) || t(c.label)}
    />
  );
};

export default FilterDropdown;
